import Vue from 'vue'
import Router from 'vue-router'
import login from '@/view/login'
//import Layout from '@/layout/layout'
import ls from "@/common/localStorage"
import store from '../store/index'

Vue.use(Router)

export const routes = [
	{
		path: '/login',
		name: 'login',
		component: login,
		meta:{
			auth:false,//路由前置守卫是否校验
			title:'登录'
		}
	},
	{
		name:'home',
		path: '/',
//		hidden:true,
		meta:{auth:true},
		component: () => import('@/view/homePages/home'),
//		component:Layout,
//		redirect:'/home',
//		children:[
//			{
//				path: 'home',
//				name: 'home',
//				component: () => import('@/view/homePages/home'),
//				meta:{auth:true}
//			}
//		]
	},
	
]

export const router = new Router({
//mode: 'history',
  routes
})

export const asyncRouterMap = [
	{}
]

router.beforeEach((to,from,next) => {
	if(to.matched.some( m => m.meta.auth)){
		
		if(to.path === '/login' && ls.getItem('token')){
			next("/home");
		}else{
//			console.log(store.state.user.isLogin);
			if(ls.getItem('token')){
				next();
			}else{
				console.log("没有登录");
				next({
					name:'login',params: { Path: to.path }
//					query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
				})
			}
		}
	}else{
		next();
	}
})



export default router





// WEBPACK FOOTER //
// ./src/router/index.js